import axios from "axios"

export default {
  async getEPD(dataOptions, search = "") {
    const { sortBy, sortDesc, page, itemsPerPage } = dataOptions;
    var url = `animalGenetics?page=${page}&limit=${itemsPerPage}`;
    if (search != "") url = `${url}&searchPhrase=${search}`;
    if (sortBy.length === 1 && sortDesc.length === 1)
      url = `${url}&sortCol=${sortBy[0]}&sortOrder=${sortDesc[0] ? 'DESC' : 'ASC'}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async getSingleEPD(animalNumber) {
    var url = `animalGenetics/${animalNumber}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async assignAnimalsToGroup(data) {
    const url = process.env.VUE_APP_PYTHON_BACKEND || 'https://lgcom-api-dev.dimitra.dev'
    return await axios
      .post(url + "/assignGroup", data)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async changeToMaintainanceMode() {
    const url = process.env.VUE_APP_PYTHON_BACKEND || 'https://lgcom-api-dev.dimitra.dev'
    return await axios
      .post(url + "/resetEPD")
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async createEPDrecordV1(data) {
    const url = process.env.VUE_APP_PYTHON_BACKEND || 'https://lgcom-api-dev.dimitra.dev'
    return await axios
      .post(url + "/addAnimalEpd", data)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async updateEPDrecordV1(data) {
    const url = process.env.VUE_APP_PYTHON_BACKEND || 'https://lgcom-api-dev.dimitra.dev'
    return await axios
      .put(url + "/updateAnimalEpd", data)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  //from lgcloud
  async getAnimalDetail(animalData) {
    const url = process.env.VUE_APP_PYTHON_BACKEND || 'https://lgcom-api-dev.dimitra.dev'
    return axios
    .post(url + "/checkAnimal", animalData)
    .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },



  async createEPDrecord(data) {
    const url = process.env.VUE_APP_PYTHON_BACKEND || 'https://lgcom-api-dev.dimitra.dev'
    return await axios
      .post(url + "/addAnimalEpdNew", data)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async updateEPDrecord(data) {
    const url = process.env.VUE_APP_PYTHON_BACKEND || 'https://lgcom-epdapi-dev.dimitra.dev'
    return await axios
      .put(url + "/updateAnimalEpdNew", data)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async getEPDList(dataOptions, search = "") {
    const { sortBy, sortDesc, page, itemsPerPage, tab } = dataOptions;
    var url = `animalGenetics/list?tab=${tab}&page=${page}&limit=${itemsPerPage}`;
    if (search != "") url = `${url}&searchPhrase=${search}`;
    if (sortBy.length === 1 && sortDesc.length === 1)
      url = `${url}&sortCol=${sortBy[0]}&sortOrder=${sortDesc[0] ? 'DESC' : 'ASC'}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async getEPDCount() {
    var url = `animalGenetics/count`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async getSingleEpdInfo(animalNumber, tab = null) {
    let url = `/animalGenetics/details/${animalNumber}?page=1&limit=1`
    if (tab)
      url = `${url}&tab=${tab}`
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async uploadGenetics(data) {
    return await axios.post('animalGenetics/import', data)
      .then(({ data }) => data)
      .catch(error => Promise.reject(error));
  },
  async deleteAnimalEpd(animalNumber) {
    return await axios.delete(`animalGenetics/${animalNumber}`)
      .then(({ data }) => data)
      .catch(error => Promise.reject(error));
  },

  async updateAnimalSubmitStatus(animalId) {
    const data = { animalId };
    return await axios.put(`animalGenetics/submit`, data)
      .then(({ data }) => data)
      .catch(error => Promise.reject(error));
  }
}